export const MIN_PATH_TIME = 5000; // Minimum path time in milliseconds

// NEW: Emoji Rescue Game Constants
export const UFO_SIZES = {
  basic: 48,
  armored: 52,
  stealth: 44
} as const;

export const RESCUE_ANIMATION_DURATIONS = {
  ufo_break: 800,
  emoji_celebrate: 1200
} as const;

export const UFO_COLORS = {
  basic: {
    dome: '#4A90E2',
    base: '#7B68EE',
    lights: '#FFD700'
  },
  armored: {
    dome: '#607D8B',
    base: '#455A64',
    lights: '#FF5722'
  },
  stealth: {
    dome: '#424242',
    base: '#212121',
    lights: '#ed1c1c'
  }
} as const;

export const TRACTOR_BEAM_COLOR = '#FFFF00';
export const TRACTOR_BEAM_OPACITY = 0.3;

// Animation constants
export const EMOJI_FLOAT_DURATION = 2000; // milliseconds
export const UFO_HOVER_AMPLITUDE = 3; // pixels
export const UFO_HOVER_FREQUENCY = 0.002; // per millisecond